import React, { memo } from 'react'

import InlineGroup from 'components/Common/InlineGroup'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LineCalendarIcon from 'components/Luxkit/Icons/line/LineCalendarIcon'

interface Props {
  durationLabel: string;
}

function FlashTourDurationLabel({ durationLabel }:Props) {
  return <InlineGroup size="xs" vertical="center">
    <div>
      <LineCalendarIcon colour="primary" />
    </div>
    <BodyText variant="medium" format="titlecase" weight="bold">{durationLabel}</BodyText>
  </InlineGroup>
}

export default memo(FlashTourDurationLabel)
